import { render, staticRenderFns } from "./lookingForPhysiotherapist.vue?vue&type=template&id=1c8ac49b&scoped=true"
import script from "./lookingForPhysiotherapist.vue?vue&type=script&lang=js"
export * from "./lookingForPhysiotherapist.vue?vue&type=script&lang=js"
import style0 from "./lookingForPhysiotherapist.vue?vue&type=style&index=0&id=1c8ac49b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8ac49b",
  null
  
)

export default component.exports